module.exports = __webpack_public_path__ + "img/COPY.b9d5a3ca.svg";